import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const ShutDownGlyph = /*#__PURE__*/createElement("g", {
  id: "shut_down"
}, /*#__PURE__*/createElement("path", {
  d: "M43.48 47.85v-29.2c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5v29.2c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5"
}), /*#__PURE__*/createElement("path", {
  d: "M30.68 32.55c-14.7 10.9-7 34.3 11.3 34.3s26.1-23.4 11.3-34.3c-.7-.5-1.6-.3-2.1.3-.5.7-.3 1.6.3 2.1 12.4 9.2 5.9 28.9-9.6 28.9s-22-19.7-9.6-28.9c.7-.5.8-1.4.3-2.1-.3-.6-1.3-.8-1.9-.3"
}));
const ShutDown = createSvg({
  name: 'shut_down',
  path: ShutDownGlyph
});

export default ShutDown;
export { ShutDownGlyph };
